import React, { useEffect, useState } from 'react';
import moment from "moment";
import {
  EuiButton,
  EuiFormRow,
  EuiPopover,
  EuiSpacer,
  EuiDatePickerRange,
  EuiPanel,
  EuiSwitch,
  EuiFlexGroup,
  EuiFlexItem,
} from '@elastic/eui';
import SelectorFecha from '../../../../../../shared/components/Combos/Fecha';
import { ToSQL } from '../../../../../../shared/utils/fecha';
import ComboSociedadesContainer from '../../../../components/Combos/Sociedades/container';
//import { optionTodas } from '../../../../components/Combos/Sociedades/functions';

export const SelectorDescargaCosteDNSociedad = (props) =>{

    const {onSave} = props;
    const fIni = moment().startOf('year');
    const fFin = moment().endOf('month');

    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [fechaIni, setFechaIni] = useState(fIni);
    const [fechaFin, setFechaFin] = useState(fFin);
    
    const [sociedades, setSociedades] = useState(undefined);
    const [porcentaje, setPorcentaje] = useState(false);

    useEffect(()=>{
      if(isPopoverOpen)
      {
        setSociedades(undefined);
        setPorcentaje(false);
      }
    },[isPopoverOpen])

    const onChangeSociedades = (values) =>{
      const count = values.length;
      if(values.length>1 && values[0].value === undefined)
        values.shift();
      else if(values.length>1 && values[count-1].value === undefined)
      {
        values.splice(0,count-1);
      }

      setSociedades(values)
    }

    const onButtonClick = () => setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
    const closePopover = () => setIsPopoverOpen(false);

    const button = (
        <EuiButton size='s' iconType="arrowDown" iconSide="right" onClick={onButtonClick} fill style={{borderRadius:'0px'}}>
        {`Dedicación`}
        </EuiButton>
    );

    const getPanelSociedades = ()=>(
      isPopoverOpen === true && (
        <EuiPanel style={{maxWidth:'35vw'}}>
            <EuiFlexGroup direction='column'>
              <EuiFlexItem>
              <EuiSwitch label="Porcentaje" checked={porcentaje} onChange={()=>setPorcentaje(!porcentaje)}/>
              </EuiFlexItem>
              
              <EuiFlexItem>
              <ComboSociedadesContainer optionAll firstDefault singleSelection={false} selectedOptions={sociedades} onChange={(value) =>{onChangeSociedades(value)}}/>
              </EuiFlexItem>
              
              <EuiFlexItem>
              <EuiButton className='btn-download-popup' fullWidth fill size='s' onClick={()=>save('SH')}>{`Fichero Dedicación Sociedades/Horas`}</EuiButton>
              </EuiFlexItem>
              
            </EuiFlexGroup>
          </EuiPanel> 
      )
    )

    const save = (tipo) =>{
        const fi = ToSQL(fechaIni,"-")
        const ff = ToSQL(fechaFin,"-")
        const filter = {fechaDesde:fi,fechaHasta:ff}

        if(tipo==='SH')
        {
          const sociedadesSel = sociedades!==undefined ? sociedades.map((s)=> s.value).join(';') : null;
          onSave && onSave.handleDownloadDedicacionHoras({...filter,...{sociedades:sociedadesSel,esPorcentaje:porcentaje}});
        }
        else
          onSave && onSave.handleDownloadDatosCoste({...filter,...{tipo:tipo}});
        closePopover();
    }

    return (
        <EuiPopover
          button={button}
          isOpen={isPopoverOpen}
          closePopover={closePopover}>
          <EuiFormRow
            fullWidth
            label="Rango de fechas"
            id="asdf"
            hasChildLabel={false}>
            
            <EuiDatePickerRange
             fullWidth
            startDateControl={
                <SelectorFecha
                selected={fechaIni}
                onChange={(value)=>setFechaIni(value)}
                isInvalid={fechaIni > fechaFin}
                aria-label="Inicio"
                />
            }
            endDateControl={
                <SelectorFecha
                selected={fechaFin}
                onChange={(value)=>setFechaFin(value)}
                isInvalid={fechaIni > fechaFin}
                aria-label="Fin"
                />
            }
            />
          </EuiFormRow>
    
          <EuiSpacer />
    
          <EuiButton className='btn-download-popup' fullWidth fill size='s' onClick={()=>save('DN')}>{`Fichero Costes Por DN/SG`}</EuiButton>
          <EuiSpacer />
          <EuiButton className='btn-download-popup' fullWidth fill size='s' onClick={()=>save('SO')}>{`Fichero Costes Por Sociedad`}</EuiButton>
          <EuiSpacer />
          <EuiButton className='btn-download-popup' fullWidth fill size='s' onClick={()=>save('US')}>{`Horas Facturables Por Usuario`}</EuiButton>
          <EuiSpacer />
         
          {/* <EuiPanel style={{maxWidth:'35vw'}}> */}
          {getPanelSociedades()}
        </EuiPopover>
      );
}